import React from "react";

export const ProgressBarBase: React.FC<
  React.HtmlHTMLAttributes<HTMLDivElement>
> = ({ ...props }) => <div {...props} />;
